import type { ReactionId } from "./emotionCatalog";

const AUDIO_SRC: Partial<Record<ReactionId, string>> = {
  triumph_wooo: "/audio/triumph_wooo.mp3",
  happy_affirm: "/audio/happy_affirm.mp3",
  happy_laugh: "/audio/happy_laugh.mp3",
  sad_sigh: "/audio/sad_sigh.mp3",
  sad_wailing: "/audio/sad_wailing.mp3",
  fear_gasp: "/audio/fear_gasp.mp3",
  fear_scream: "/audio/fear_scream.mp3",
  anger_growl: "/audio/anger_growl.mp3",
  anger_shout: "/audio/anger_shout.mp3",
  disgust_tongue: "/audio/disgust_tongue.mp3",
  disgust_yuck: "/audio/disgust_yuck.mp3",
  surprise_inhale: "/audio/surprise_inhale.mp3",
  contempt_tsk: "/audio/contempt_tsk.mp3",
  contempt_snort: "/audio/contempt_snort.mp3",
  confused: "/audio/confused.mp3",
  sleepy_snore: "/audio/sleepy_snore.mp3",
  eating_munch: "/audio/eating_munch.mp3"
};

export async function playReactionAudio(reaction: ReactionId): Promise<void> {
  const src = AUDIO_SRC[reaction];
  if (!src) {
    return;
  }

  try {
    const element = new Audio(src);
    element.preload = "auto";
    element.volume = reaction === "sleepy_snore" ? 0.7 : 1;
    await element.play();
  } catch (error) {
    console.warn(`Failed to play ${reaction}`, error);
  }
}

export function playCrunchLayer(): Promise<void> {
  return playReactionAudio("eating_munch");
}
